import { RailDock } from '../shell-next/rail/RailDock';
import { CustomInviteFormProvider } from './CustomInviteFormProvider';

/**
 * The right-hand dock, mounted at `AppRouter.tsx`'s `AuthenticatedLayout`,
 * OUTSIDE the shell frame and inside `EnrollQueueProvider` /
 * `FlowChatSessionsProvider`. It always renders the Glaze `RailDock`: the V1
 * `EnrollQueueSidebar` and the retired flag switch that chose between the
 * two are gone (no setting gates anything about the shell).
 *
 * The dock is where the URL<->state sync for `?request=` and the two chat
 * params lives (`useDockUrlSync`, called by `RailDock`), so it must stay
 * mounted on every authenticated route from first paint — a pasted deep link
 * has to be able to open the dock on the right tab on a cold load.
 * `useDockUrlSync`'s "exactly one caller" contract (two callers would be two
 * writers on one URL) holds because `RailDock` is the only caller.
 *
 * `CustomInviteFormProvider` wraps the dock so the Invite tab's draft outlives
 * the dock's close and tab switches (`RailDock` unmounts its body in both).
 *
 * `QueueContentShift` (which pads the main content against the fixed aside's
 * width on unframed routes) is a separate, shell-level component.
 */
export function EnrollQueueDock() {
  return (
    <CustomInviteFormProvider>
      <RailDock />
    </CustomInviteFormProvider>
  );
}
